import { render, staticRenderFns } from "./TheTip.vue?vue&type=template&id=2c1770cc&"
import script from "./TheTip.vue?vue&type=script&lang=js&"
export * from "./TheTip.vue?vue&type=script&lang=js&"
import style0 from "./TheTip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/bsjung/work/xtc/trading-chart-js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1770cc')) {
      api.createRecord('2c1770cc', component.options)
    } else {
      api.reload('2c1770cc', component.options)
    }
    module.hot.accept("./TheTip.vue?vue&type=template&id=2c1770cc&", function () {
      api.rerender('2c1770cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TheTip.vue"
export default component.exports